const styles = () => ({
    root: {
        minWidth: 90,
    },
});

export default styles;
